var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 6.46094L11.6562 8.71094C11.4688 8.89844 11.1641 8.75781 11.1641 8.52344V6.8125H2.28125C2.11719 6.8125 2 6.69531 2 6.53125V5.96875C2 5.82812 2.11719 5.6875 2.28125 5.6875H11.1641V4C11.1641 3.76562 11.4688 3.625 11.6562 3.8125L13.9062 6.0625C14.0234 6.17969 14.0234 6.34375 13.9062 6.46094ZM2.07031 10.9609C1.95312 10.8438 1.95312 10.6797 2.07031 10.5625L4.32031 8.3125C4.50781 8.125 4.8125 8.26562 4.8125 8.5V10.1875H13.7188C13.8594 10.1875 14 10.3281 14 10.4688V11.0312C14 11.1953 13.8594 11.3125 13.7188 11.3125H4.8125V13.0234C4.8125 13.2578 4.50781 13.3984 4.32031 13.2109L2.07031 10.9609Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.d385d5f8370529b9553bce38ce66a96b.svg";
export { ForwardRef as ReactComponent };